/* eslint-disable no-nested-ternary */
import { useEffect, useState } from 'react';
import { Box, Drawer, Grid, IconButton, Typography, Tooltip, CircularProgress } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { getThirdLevelFacets, getThirdLevelImages, getThirdLevelProducts } from 'store/slices/healthContent';
import { dispatch, useSelector } from 'store';
import SpectsProduct from './SpectsProduct';
import SpectsImages from './SpectsImages';
import SpectsFacets from './SpectsFacets';
import { useLocation, Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { ThirdLevel } from 'types/components/shared';

const DrawerProduct = ({
    handledClickProduct,
    openModal,
    idProd,
    typeReq
}: {
    handledClickProduct: any;
    openModal: any;
    idProd: number | null;
    typeReq: string;
}) => {
    const [product, setProduct] = useState<ThirdLevel[]>();
    const { thirdLevelProducts, loadingThirdLevel } = useSelector((state) => state.healthContent);
    const { thirdLevelImages } = useSelector((state) => state.healthContent);
    const { thirdLevelFacets } = useSelector((state) => state.healthContent);
    const location = useLocation();
    const intl = useIntl();
    useEffect(() => {
        const idMerchant = new URLSearchParams(location.search).get('idMerchant');
        if (!idProd) return;
        if (typeReq === 'products') {
            dispatch(getThirdLevelProducts({ idProd, idMerchant }));
        }
        if (typeReq === 'images') {
            dispatch(getThirdLevelImages({ idProd, idMerchant }));
        }
        if (typeReq === 'facets') {
            dispatch(getThirdLevelFacets({ idProd, idMerchant }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idProd, typeReq]);

    useEffect(() => {
        if (typeReq === 'products') {
            setProduct(thirdLevelProducts);
        }
        if (typeReq === 'images') {
            setProduct(thirdLevelImages);
        }
        if (typeReq === 'facets') {
            setProduct(thirdLevelFacets);
        }
    }, [thirdLevelFacets, thirdLevelImages, thirdLevelProducts, typeReq]);

    return (
        <>
            {product ? (
                <Drawer anchor="right" open={openModal} onClose={handledClickProduct(false)}>
                    {loadingThirdLevel ? (
                        <Box sx={{ width: '600px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={{ width: '600px' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                                    <Typography variant="h2" sx={{ paddingTop: 5 }}>
                                        {intl.formatMessage({ id: 'information_to_complete' })}
                                    </Typography>
                                    <Tooltip title={intl.formatMessage({ id: 'edit_product' })}>
                                        <IconButton
                                            component={Link}
                                            to={`/loolu/admin/products/detail-product/${idProd}`}
                                            target="_blank"
                                            sx={{
                                                position: 'fixed',
                                                top: 30,
                                                right: 30,
                                                bgcolor: 'rgb(124, 77, 255)',
                                                '&:hover': { background: 'rgb(75, 27, 207)' }
                                            }}
                                        >
                                            <EditIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', paddingRight: 5, paddingTop: 3 }}>
                                        IdProduct : {idProd}
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    {typeReq === 'products' ? (
                                        <SpectsProduct product={product} />
                                    ) : typeReq === 'images' ? (
                                        <SpectsImages product={product} />
                                    ) : typeReq === 'facets' ? (
                                        <SpectsFacets product={product} />
                                    ) : (
                                        <></>
                                    )}
                                </Grid>
                            </Grid>
                        </Box>
                    )}
                </Drawer>
            ) : (
                <></>
            )}
        </>
    );
};

export default DrawerProduct;
